<template>
  <el-dialog
            title="Update Company Information"
            :visible.sync="innerValue"
            width="530px"
            height="100%"
            :close-on-click-modal=false
            :close-on-press-escape=false
            v-loading="loading"
  >
    <el-card class="box-card">
      <el-form>
        <el-form-item label="Company Name">
          <el-input v-model="name" class="u-pt2"></el-input>
        </el-form-item>
        <el-form-item label="BriteCore URL">
          <el-input v-model="britecoreURL" class="u-pt2" placeholder="https://..."></el-input>
        </el-form-item>

        <el-form-item label="BriteCore API Key">
          <el-input v-model="britecoreAPIKey" class="u-pt2"></el-input>
        </el-form-item>
        <el-form-item label="Active company">
          <el-switch v-model="enabled" class="enable-company-switch"></el-switch>
        </el-form-item>
      </el-form>
    </el-card>

    <div class="u-mt4">
      <el-button @click="updateCompany" type="danger" class="display-block" :disabled="(!name || !britecoreURL)">Update Company</el-button>
    </div>

  </el-dialog>
</template>

<script>

import {mapActions} from 'vuex'
import {axiosWrapper} from '@/shared/api.utils'
import config from '@/config'
import axios from 'axios'


export default {
  name: 'ba-foobar-dialog',
  components: {},
  props: {
    value: {type: Boolean},
    id: {type: String},
    britecoreURL: {type: String},
    name: {type: String},
    enabled: {type: Boolean}
  },
  watch: {
    value: {
      handler (value) {
        this.innerValue = value
      },
      immediate: true
    },
    innerValue: {
      handler (innerValue) {
        this.$emit('input', innerValue)
        this.$emit('change', innerValue)
      },
      immediate: true
    },
  },
  data () {
    return {
      britecoreAPIKey: null,
      loading: false,
      innerValue: false,
    }
  },
  methods: {
    ...mapActions('login', ['init']),
    ...mapActions('shared', ['loadHealthcheck']),
    async updateCompany () {
      this.loading = true

      try {
        await axiosWrapper(axios.post(
          `${config.url}/update-company/${this.id}`,
          {
            company_name: this.name,
            britecore_url: this.britecoreURL,
            britecore_api_key: this.britecoreAPIKey,
            enabled: this.enabled,
          }
        ))
        this.$alert(
          `Company updated`,
          'Company was successfully updated',
        )
      } catch (error) {
        this.$alert(
          error.response.message,
          'Failed to update company',
        )
        this.loading = false
        return
      }

      await this.init() // perform company refresh via carrier-user retrieval
      this.loadHealthcheck() // don't wait for Healthchecks
      this.clearData()
      this.innerValue = false
      this.loading = false
    },
    clearData () {
      this.companyName = null
      this.britecoreURL = null
      this.britecoreAPIKey = null
    },
  },
}
</script>

<style lang="scss" scoped>
  .enable-company-switch {
    margin-top: -26px;
  }
</style>